import type { ReactElement } from 'react';
import './revenue.css';
import { Revenue } from './Revenue.tsx';

export const REVENUE_SHORTCUTS: [string, string][] = [['1–6', 'Revenue: group by site, merchant, coupon, placement, network, day']];

export function revenuePage(path: string): ReactElement | null {
  return path === '/revenue' ? <Revenue /> : null;
}
